import { getStorage } from "../../utils/storage";

export default async (filters) => {
  const { merchantID } = await getStorage("merchantID");

  let params = {
    merchantId: merchantID,
    // merchantId: "300014",
    page: filters.page || 0,
    size: filters.limit || 20,
  };

  if (filters.transactionStatus) {
    params.transactionResult = filters.transactionStatus.value;
  }

  if (filters.paymentMode) {
    params.paymentMode = filters.paymentMode.value;
  }

  if (filters.startDate && filters.endDate) {
    params.startDate = filters.startDate;
    params.endDate = filters.endDate;
  }

  if (filters.transactionSubType) {
    params.transactionSubType = filters.transactionSubType.value;
  }

  return params;
};
